import {ORDER_TYPES} from "nandos-middleware-api/model/food-basket";
import UserProduct from "nandos-middleware-api/model/user-product";
import FoodBasketItem from "nandos-middleware-api/model/food-basket-item";
import GiftCardBasketItem from "nandos-middleware-api/model/gift-card-basket-item";

export function _getOrderTypeFromBasket (basket) {
  switch (basket.orderType) {
    case ORDER_TYPES.DELIVERY:
      return 'delivery'
    case ORDER_TYPES.COLLECTION:
      return basket.kerbsideCollect ? 'kerbside' : 'collection'
    case ORDER_TYPES.EAT_IN:
      return 'eatIn'
  }
}

export function _toMoney (val) {
  return parseFloat(val / 100)
}

export function getTrackingDataFromItem (item) {
  if (item instanceof UserProduct) {
    return _getTrackingDataFromProduct(item)
  } else if (item instanceof FoodBasketItem) {
    return _getTrackingDataFromFoodBasketItem(item)
  } else if (item instanceof GiftCardBasketItem) {
    return _getTrackingDataFromGiftCard(item)
  } else {
    return item
  }
}

export function _getTrackingDataFromProduct (product) {
  return {
    id: product.getId(),
    name: product.getName(),
    price: _toMoney(product.computePrice()),
    variant: product.getConfigurationDescription(),
    quantity: product.orderQuantity,
  }
}

export function _getTrackingDataFromFoodBasketItem (item) {
  return {
    id: item.id,
    name: item.productName,
    price: _toMoney(item.productPrice),
    variant: item.computedDescription,
    quantity: item.quantity,
  }
}

export function _getTrackingDataFromGiftCard (item) {
  return {
    id: `nandos-gift-card`,
    name: 'Gift Card',
    price: _toMoney(item.price),
    variant: `${_toMoney(item.price)}, design: ${item.srcImageUrl}`,
    quantity: item.cards.length,
  }
}


export const MIDDLEWARE_SERVICE_EVENTS = {
  user: "USER",
  setAttributionData: "ATTRIBUTION",
  productImpressions: "PRODUCT_IMPRESSIONS",
  productClick: "PRODUCT_CLICK",
  productView: "PRODUCT_VIEW",
  addToCart: "ADD_TO_CART",
  removeFromCart: "REMOVE_FROM_CART",
  checkout: "CHECKOUT",
  paymentOption: "PAYMENT_OPTION",
  purchase: "PURCHASE",
  VirtualPageview: "PAGE_VIEW",
  paymentInfo: "PAYMENT_INFO",
  signUp: "SIGN_UP",
  login: "LOGIN"
}